import ThemeProvider from '@shazambanking/sdk/components/ThemeProvider';
import { ThemeState } from '@shazambanking/sdk/types/state';
import * as React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { RESET_PASSWORD_URL, THEME_URL } from './Constants';
import UserConfirmation from './UserConfirmation';
import UserEnrollment from './UserEnrollment';

interface IState {
  theme?: ThemeState;
}

class App extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      theme: undefined
    }
    fetch(THEME_URL).then(response => response.json()).then(data => this.setState({ theme: data }));
  }

  // tslint:disable: jsx-no-lambda
  public render() {
    
    const host = window.location.hostname;
    const hostParts = host.split('.');

    const serviceUrl = window.location.protocol + "//" + window.location.hostname;
    let changePasswordUrl = serviceUrl;
    if(hostParts.length > 2 ) {
      changePasswordUrl =  window.location.protocol + "//" + hostParts[0] + "-service." + hostParts[1] + '.' + hostParts[2] +  RESET_PASSWORD_URL;
    }
    return (
      <ThemeProvider theme={this.state.theme}>
        <BrowserRouter basename="/user-enrollment">
          <Switch>
            <Route path="/" exact={true}>
              <Redirect to={"/enroll"} />
            </Route>
            <Route path={"/login"} exact={true} component={() => {
              window.location.href = serviceUrl;
              return null;
            }} />
            <Route path={"/changePassword"} exact={true} component={() => {
              window.location.href = changePasswordUrl;
              return null;
            }} />
            <Route path={"/enroll"} exact={true} component={UserEnrollment} />
            <Route path={"/confirmation"} exact={true} component={UserConfirmation} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx